
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"54","height":"28","rx":"3","fill":"#fff"}}),_c('path',{attrs:{"d":"M23.708 20.767h-3.522l2.201-13.525h3.522l-2.201 13.525zM17.224 7.242l-3.357 9.302-.397-2.003-1.185-6.082s-.143-1.217-1.67-1.217h-5.55L5 7.47s1.697.353 3.683 1.546l3.06 11.75h3.668l5.603-13.525h-3.79zM44.92 20.767h3.234L45.334 7.24h-2.83c-1.307 0-1.625 1.008-1.625 1.008l-5.252 12.518h3.67l.735-2.01h4.476l.412 2.01zm-3.874-4.785l1.85-5.061 1.04 5.061h-2.89zm-5.144-5.488l.503-2.904S34.855 7 33.238 7c-1.748 0-5.897.764-5.897 4.477 0 3.495 4.87 3.538 4.87 5.373 0 1.836-4.369 1.507-5.81.35l-.524 3.036S27.45 21 29.852 21c2.403 0 6.028-1.244 6.028-4.63 0-3.517-4.914-3.845-4.914-5.373 0-1.53 3.43-1.333 4.936-.503z","fill":"#2566AF"}}),_c('path',{attrs:{"d":"M13.47 14.54l-1.185-6.082s-.143-1.218-1.67-1.218h-5.55L5 7.47s2.667.552 5.226 2.623c2.446 1.98 3.244 4.447 3.244 4.447z","fill":"#E6A540"}})])
          )
        }
      }
    